import React from 'react';

const PaymentPolicy = () => {
  return (
    <div
      style={{
        backgroundColor: '#1D1D1D',
        color: '#333',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        margin: '20px auto',
        maxWidth: '1300px',
        textAlign: 'justify',
      }}
    >
      <h3 style={{ marginBottom: '15px', fontWeight: 'bold', color:"#fff" }}>Payment Policy</h3>
      <p>20% payment is required for booking confirmation.</p>
      <p>If the booking is cancelled by the customer, the amount is non-refundable.
        The remaining payment is due at the time of work completion and handover. Late
        payments will not be accepted.
      </p>
    </div>
  );
};

export default PaymentPolicy;
